import React from 'react';
import { formatDateAr, money, movementTitle } from '../../utils/loyalty';

const MovementRow = ({ mov }) => {
  const delta = Number(mov.delta != null ? mov.delta : mov.puntos || 0);
  const positive = delta >= 0;
  return (
    <div className="py-4 flex items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="font-black">{movementTitle(mov)}</p>
        <p className="text-sm text-gray-400 mt-0.5">
          {formatDateAr(mov.fecha)}
          {mov.saldoMostrado != null ? ` · Saldo ${money(mov.saldoMostrado)} pts` : ''}
        </p>
      </div>
      <p className={`shrink-0 font-black ${positive ? 'text-gray-900' : 'text-maja-red'}`}>
        {positive ? '+' : ''}{money(delta)}
      </p>
    </div>
  );
};

export default MovementRow;
